import { SorterResult } from 'antd/es/table/interface';
import { TablePaginationConfig } from 'antd/lib';
import { useEffect, useState } from 'react';

import { RingTableFilterData } from 'business/production-and-performance/pages/ring-table';
import { RingsTableContainer } from 'business/production-and-performance/pages/ring-table/components/ring-table-container';
import {
  RingTableColumnKeys,
  RingTableRow,
} from 'business/production-and-performance/pages/ring-table/types';
import { useProdAndPerfFilters } from 'business/production-and-performance/providers/prod-and-perf-filters-provider';
import { TableParamsProps } from 'business/providers/table-params';
import { FilterDataSetter } from 'technical/filter-data';

const defaultCurrentPage = 1;
const defaultPageSize = 50;

const defaultOrderBy = {
  sortOrder: 'descend',
  sortField: RingTableColumnKeys.RingNumber,
} as const;

export const RingsTableWithPagination = ({
  setFilterData,
}: {
  setFilterData: FilterDataSetter<RingTableFilterData>;
}) => {
  const filters = useProdAndPerfFilters();

  const [tableParams, setTableParams] = useState<TableParamsProps>({
    current: defaultCurrentPage,
    pageSize: defaultPageSize,
    ...defaultOrderBy,
  });

  const handleChange = (
    newPagination: TablePaginationConfig,
    _: unknown,
    sorter: SorterResult<RingTableRow> | SorterResult<RingTableRow>[],
  ) => {
    setTableParams({
      current: defaultCurrentPage,
      pageSize: defaultPageSize,
      ...newPagination,
      sortOrder: Array.isArray(sorter)
        ? defaultOrderBy.sortOrder
        : sorter.order,
      sortField: Array.isArray(sorter)
        ? defaultOrderBy.sortField
        : sorter.field,
    });
  };

  // Used to reset pagination on filters change.
  // Table params should be in a provider around filters.
  useEffect(() => {
    setTableParams((params) => ({ ...params, current: defaultCurrentPage }));
  }, [filters]);

  return (
    <RingsTableContainer
      tableParams={tableParams}
      onChange={handleChange}
      setFilterData={setFilterData}
    />
  );
};
